module.exports = __webpack_public_path__ + "media/images/display/blur-text-0-7f8c20f3127bc205dc1ebb1ab69a9aac.png";